import { createContext, useContext, useMemo, useState } from "react";
import { useEdgesState, useNodesState } from "reactflow";
import { initialEdges, initialNodes } from "../initialData";

const FlowNodesContext = createContext();

export const FlowNodesProvider = ({ children, ...res }) => {
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);
  const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
  const [theme, setTheme] = useState("light");
  const [params, setParams] = useState([]);
  const [dataNode, setDataNode] = useState();

  const value = useMemo(
    () => ({
      edges,
      setEdges,
      onEdgesChange,
      nodes,
      setNodes,
      onNodesChange,
      theme,
      setTheme,
      params,
      setParams,
      dataNode,
      setDataNode,
      ...res,
    }),
    [edges, nodes, theme, params, dataNode, res]
  );

  return (
    <FlowNodesContext.Provider value={value}>
      {children}
    </FlowNodesContext.Provider>
  );
};

export const useFlowNodes = () => {
  const context = useContext(FlowNodesContext);
  if (!context) {
  }
  return context;
};

export { FlowNodesContext };
